import { useQuery } from "@tanstack/react-query";
import { fetchMasterPlaylist, groupEntriesBySeasonAndRound, type ArchiveEntry, type SeasonGrouping } from "@/lib/archive";
import { useStore } from "@/lib/store";

export function useArchivePlaylists() {
  const { state } = useStore();
  const userId = state.currentUser?.id;

  return useQuery<{ entries: ArchiveEntry[]; grouped: SeasonGrouping[] }>({
    queryKey: ["playlist-archive", "master", userId],
    queryFn: async () => {
      console.log('[useArchivePlaylists] 🔄 Fetching archive playlists...', { userId });
      const entries = await fetchMasterPlaylist(false, userId);
      console.log('[useArchivePlaylists] ✅ Received', entries.length, 'entries');
      const grouped = groupEntriesBySeasonAndRound(entries);
      console.log('[useArchivePlaylists] 📊 Grouped into', grouped.length, 'seasons');
      return {
        entries,
        grouped,
      };
    },
    staleTime: 1000 * 60 * 1, // 1 minute stale time (was 10 minutes)
    refetchOnWindowFocus: true, // Refetch when window regains focus
  });
}


